import { STATE_LOGIN, STATE_SIGNUP } from "components/AuthForm";
import { EmptyLayout, MainLayout } from "components/Layout";
import PageSpinner from "components/PageSpinner";
import AuthPage from "pages/AuthPage";
import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./styles/reduction.scss";
import { useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";

// const AlertPage = React.lazy(() => import("pages/AlertPage"));
// const AuthModalPage = React.lazy(() => import("pages/AuthModalPage"));
const AllIssues = React.lazy(() => import("pages/Issues/AllIssues"));
// const ButtonGroupPage = React.lazy(() => import("pages/ButtonGroupPage"));
// const ButtonPage = React.lazy(() => import("pages/ButtonPage"));
const CardPage = React.lazy(() => import("pages/CardPage"));
// const ChartPage = React.lazy(() => import("pages/ChartPage"));
const DashboardPage = React.lazy(() => import("pages/DashboardPage"));

const EditIssue = React.lazy(() => import("pages/Issues/EditIssue"));
const IssueDetails = React.lazy(() => import("pages/Issues/Details"));
const NewIssue = React.lazy(() => import("pages/Issues/NewIssueForm"));
const NewCulpability = React.lazy(() =>
  import("pages/Culpability/NewCulpability")
);
const AllCulpability = React.lazy(() =>
  import("pages/Culpability/AllCulpability")
);
const CulpabilityDetails = React.lazy(() =>
  import("pages/Culpability/Details")
);
const EditCulpability = React.lazy(() =>
  import("pages/Culpability/EditCulpability")
);
// const TablePage = React.lazy(() => import("pages/TablePage"));
// const TypographyPage = React.lazy(() => import("pages/TypographyPage"));
// const WidgetPage = React.lazy(() => import("pages/WidgetPage"));

const getBasename = () => `/${process.env.PUBLIC_URL.split("/").pop()}`;

// Example: Authenticated routes wrapper
const AuthenticatedRoutes = () => (
  <MainLayout>
    <Suspense fallback={<PageSpinner />}>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/cards" element={<CardPage />} />
        <Route path="/issue/all" element={<AllIssues />} />
        <Route path="/issue/details/:id" element={<IssueDetails />} />
        <Route path="/issue/new" element={<NewIssue />} />
        <Route path="/issue/update/:id" element={<EditIssue />} />
        <Route path="/culpability/new" element={<NewCulpability />} />
        <Route path="/culpability/all/:id" element={<AllCulpability />} />
        <Route
          path="/culpability/details/:id"
          element={<CulpabilityDetails />}
        />
        <Route path="/culpability/update/:id" element={<EditCulpability />} />
        {/* Default redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  </MainLayout>
);

const App = ({ breakpoint }) => {
  const signIn = useSelector((state) => state.auth.logIn);
  return (
    <Router basename={getBasename()}>
      <Routes>
        {/* Public Routes */}
        <Route
          path="/login"
          element={<AuthPage authState={STATE_LOGIN} layout={EmptyLayout} />}
        />
        <Route
          path="/signup"
          element={<AuthPage authState={STATE_SIGNUP} layout={EmptyLayout} />}
        />
        {!signIn ? (
          <Route path="*" element={<AuthenticatedRoutes />} />
        ) : (
          <Route path="*" element={<Navigate to="/login" replace />} />
        )}
      </Routes>
    </Router>
  );
};

const query = ({ width }) => {
  if (width < 575) return { breakpoint: "xs" };
  if (576 < width && width < 767) return { breakpoint: "sm" };
  if (768 < width && width < 991) return { breakpoint: "md" };
  if (992 < width && width < 1199) return { breakpoint: "lg" };
  if (width > 1200) return { breakpoint: "xl" };
  return { breakpoint: "xs" };
};

export default App;
